var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as React from 'react';
import { observer, inject } from 'mobx-react';
import { IconSVG } from '@bytebrand/fe-ui-core-autobahn/iconsvg';
import { getFormattedPrice } from '@bytebrand/fe-ui-core-autobahn/utils';
import styles from './OfferModal.styl';
let FaqModal = class FaqModal extends React.Component {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "refOfferButton", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "onClose", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (event) => {
                const { hideModal } = this.props;
                event.stopPropagation();
                event.nativeEvent.stopImmediatePropagation();
                hideModal('FAQ_MODAL');
            }
        });
        Object.defineProperty(this, "renderHeader", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const { t, faqIndex } = this.props;
                const faqItemsTitle = [
                    'Wer kann dieses Abo buchen?',
                    'Wie erfolgen Übergabe und Ruckgabe?',
                    'Wie lang ist die Laufzeit?',
                    'Was kostet ein Auto Abo?'
                ];
                const questions = t(`modals:aboFaq.questions`);
                return (React.createElement("header", { className: styles.header },
                    React.createElement(IconSVG, { name: 'closeIcon', className: styles.deleteButton, onClick: this.onClose }),
                    React.createElement("h2", { className: styles.title }, faqItemsTitle)));
            }
        });
        Object.defineProperty(this, "renderDetailsSection", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (financingConfig) => {
                const { t, faqIndex } = this.props;
                const { leasing } = financingConfig;
                const financialInstitution = leasing.financialInstitution;
                const values = Object.keys(leasing).reduce((acc, key) => {
                    acc[key] = getFormattedPrice(leasing[key], '$,.2f');
                    return acc;
                }, {}); // eslint-disable-line
                const faqContent = [
                    `Bei der Buchung dieses Auto Abos gelten für den Fahrer folgende Bedingungen:
      Mindestalter 23 Jahre;
      Höchstalter 73 Jahre;
      Wohnsitz in Deutschland;
      in Besitz einer gültigen PKW Fahrerlaubnis aus einem EU Staat;
      positive Bonität;
      verifizierte Identität mittels Postident.`,
                    `Die Übergabe kann deutschlandweit bei unseren Partner-Händlern stattfinden.
      Auf Wunsch kannst du dein Auto innerhalb von Deutschland liefern lassen (zzgl. 190 € inkl. MwSt.).
      Wenn du das Auto wechseln oder dein Abo beenden möchtest, vereinbaren wir mit dir einen Rücknahmetermin und -ort im Umkreis von ca. 200 Kilometern von deinem Wohn- oder Arbeitsort.
      Auf Wunsch holen wir dein Auto für 190 € inkl. MwSt. bei dir Zuhause ab.
      Gemeinsam mit dir und einem neutralen Gutachter erfolgt eine Prüfung des Autos auf Schäden und Gebrauchsspuren.`,
                    `Die Mindestlaufzeit beträgt 6 Monate je Fahrzeug. Mit einer Frist von 3 Monaten kannst du auf ein anderes Auto wechseln oder die Nutzung beenden.`,
                    `Im monatlichen Paketpreis ist alles inklusive außer Tanken. Die Kosten sind immer transparent:
      Der monatliche Paketpreis ist abhängig vom gewählten Auto.
      Jeder weitere Kilometer, den du zusätzlich zu deinen 15.000 Freikilometern pro Jahr fährst, wird mit 0,20 € (inkl. MwSt.) berechnet.
      Optionale Fahrzeuglieferungen und -abholungen kosten 190 € (inkl. MwSt.).
      Hinzu kommt eine einmalige Startgebühr von 0 € (inkl. MwSt.) für Neukunden.
      Der Selbstbehalt für Teilkasko beträgt 1.000 €, für Vollkasko 1.000 €.
      Die Startgebühr ist bei Buchung des ersten Autos fällig.
      Der Paketpreis ist jeweils zu Monatsbeginn im Voraus fällig.
      Beides wird per Lastschrift eingezogen.`
                ];
                return (React.createElement("div", { className: styles.detailsSection },
                    React.createElement("span", null, faqContent[faqIndex])));
            }
        });
    }
    render() {
        const { financingStore: { getUserConfig }, vehicleId } = this.props;
        const financingConfig = getUserConfig(vehicleId);
        return (React.createElement("div", { className: styles.financingModal },
            this.renderHeader(),
            this.renderDetailsSection(financingConfig)));
    }
};
Object.defineProperty(FaqModal, "defaultProps", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: {
        financingConfig: {}
    }
});
FaqModal = __decorate([
    inject('financingStore'),
    observer
], FaqModal);
export default FaqModal;
